var _defs, _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _g3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22, _ellipse23, _ellipse24, _ellipse25, _ellipse26, _ellipse27, _ellipse28, _ellipse29, _ellipse30, _ellipse31, _ellipse32, _path38, _path39, _path40, _path41, _path42, _path43, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeeko(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 453.81 888.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-meeko-1{fill:#383432;}.cls-meeko-2{fill:#a9a194;}.cls-meeko-3{fill:#b5aea1;}.cls-meeko-4{fill:none;}.cls-meeko-5{clip-path:url(#clip-meeko-path);}.cls-meeko-6{fill:#000209;}.cls-meeko-7{fill:#4d4741;}.cls-meeko-8{clip-path:url(#clip-meeko-path-2);}.cls-meeko-9{fill:#958c80;}.cls-meeko-10{clip-path:url(#clip-meeko-path-3);}.cls-meeko-11{fill:#302e33;}.cls-meeko-12{fill:#aca394;}.cls-meeko-13{fill:#9f9585;}.cls-meeko-14{fill:#392a38;}.cls-meeko-15{fill:#6f585a;}.cls-meeko-16{fill:#675a4b;}.cls-meeko-17{clip-path:url(#clip-meeko-path-4);}.cls-meeko-18{fill:#fff;}.cls-meeko-19{fill:#070707;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-meeko-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-1",
    d: "M.92,473.49S8,528.85,41.38,607.65,75.45,891.58,75.45,891.58L428,893.17s52.21-58.78,8.08-135.91c0,0,17.92-38.68-5.8-128.65S395.82,386.47,319.16,389.26.92,473.49.92,473.49Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-meeko-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-2",
    d: "M186.32,908.29s13.79-85.68,62.44-87.86,92.94,10.89,140.13-26.14l47.2-37s2.9,47.92-39.94,86.41-44.29,71.15-44.29,71.15Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-meeko-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-3",
    d: "M25.11,322.56S.31,334,6.05,389.75-4.87,428.26,1.46,476s61.33,94.91,62,124.66,5.58,91.71,44.57,124.2,41.58,7.79,39.63,57.18-20.14,113.06-20.14,113.06,66.2,16.78,73.28,7,11.84-56.36,30.06-76.93,32.33-44.67,32.33-44.67-74,16.85-83.28-15.15-10-63.63,22.48-91.33S185.57,623.45,185,587.92s24.09-55.4,73.47-72.87S370.76,385,308.87,281.39Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-meeko-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-4",
    d: "M128.22,101.84s47.94-6.43,90.4,5.75,90.84-60.21,107.54-73.78c8.56-7,15.3-10.81,19.83-12.9a5.37,5.37,0,0,1,7.61,4.39c.83,9.42.76,28.11-7.86,52.83-12.68,36.33-25.12,91.83-34.89,107.3s20.79,23.59,11.54,80.69-37.16,78.4-60.78,50.4c-23.25-27.55-44.56-48-44.24-58.92s-2.36-62.83-17-71.79-26.86,35.12-35.14,46.5S147,257.07,145.82,264.74s-62.35,13-66.43,60.8,36.77,40.85,36.77,40.85,9.81,17.16,22.47,24.93c0,0-70.59-12.13-103.79-53.4-16.27-20.23-21.84-36.31-23.57-49-6.3-46.1,5.74-92.29,12.29-111,0,0-31.62-145,.6-173.63S94.46,101,128.22,101.84Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-1",
    d: "M.92,473.49S8,528.85,41.38,607.65,75.45,891.58,75.45,891.58L428,893.17s52.21-58.78,8.08-135.91c0,0,17.92-38.68-5.8-128.65S395.82,386.47,319.16,389.26.92,473.49.92,473.49Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-meeko-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-6",
    d: "M153.64,742.79l-119-132.24,10.54,84.68S109.88,744.69,153.64,742.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-6",
    d: "M142.09,622-3.62,482.44l4.94,77.79S85.28,624.44,142.09,622Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-6",
    d: "M153.49,777.78S62.17,755,52.66,734s5.7,30.44,5.7,30.44,50.42,34.25,95.13,23.78S153.49,777.78,153.49,777.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-6",
    d: "M91.33,798.71C77.52,794.39,17.15,762,12,739.63s-.48,31-.48,31S54.1,814.22,100,812.88,105.14,803,91.33,798.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-6",
    d: "M400.53,834.89c14.4-1.33,57.32-34.13,67-55s16.88,44.2,16.88,44.2-50.77,33.73-95.37,22.8S386.12,836.22,400.53,834.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-6",
    d: "M391.81,782.88c-12.52,9.08-39.76,20.65-55.87,19.74a12.26,12.26,0,0,1-11.34-13.9c1.54-11.19,8.65-26,25.58-45.52C395,691.54,393,623.64,388.83,626.44S338.55,750.19,201.24,813.55C87.91,865.85,264.05,837.6,329,826.13c2.72,1.7,6.41,2.53,11.37,2,26.55-2.72,95.68-70.89,95.68-70.89S409.18,770.28,391.81,782.88Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-7",
    d: "M309.81,420.79s31.38,37.54,27.69,88.62-44.31,206.17-44.31,206.17-104,33.84-124.93,31.38-.61-208-.61-208Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-1",
    d: "M183.77,547.64S224.84,564.37,291,526.87c2.32-1.31,4.45,2.16,2.76,4.49-13.62,18.74-49,56.91-108.72,52.08C185.08,583.44,177.27,558.77,183.77,547.64Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-1",
    d: "M177.48,595.18s41.29,10.22,86.38-13.34a3,3,0,0,1,3.49,4.87c-13.23,12.62-38.2,28.95-78.27,28Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-6",
    d: "M323.62,356.05c2.74.89,38.2,35.87,54.89,77,0,0,2.33,44.51-18.62,30.94s-15.52-5.82-14,26.38-19,298.15-104.68,295.55c-14.11-.42-30.82,5.89-40.7,3.17-50.11-13.75-43.88-58.65-19.48-54.31,29.21,5.19,83.73-9.09,91.52-47.38s-1.3-33.11-26-22.07-53,9.67-50.17,2.91,36.22-4,49.76-21.5,18.31-23.09,26.67-19.91,18.32,46.18,21.9,39.42,5.17-49,19.11-70.07S345.12,482.24,318,448.06,323.62,356.05,323.62,356.05Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-2",
    d: "M186.32,908.29s13.79-85.68,62.44-87.86,92.94,10.89,140.13-26.14l47.2-37s2.9,47.92-39.94,86.41-44.29,71.15-44.29,71.15Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-meeko-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-9",
    d: "M213.66,922.43s9.69-91.85,35.43-108.11c0,0-35.22-8.8-53.51,37.94s-23.71,73.83-23.71,73.83Z"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-3",
    d: "M25.11,322.56S.31,334,6.05,389.75-4.87,428.26,1.46,476s61.33,94.91,62,124.66,5.58,91.71,44.57,124.2,41.58,7.79,39.63,57.18-20.14,113.06-20.14,113.06,66.2,16.78,73.28,7,11.84-56.36,30.06-76.93,32.33-44.67,32.33-44.67-74,16.85-83.28-15.15-10-63.63,22.48-91.33S185.57,623.45,185,587.92s24.09-55.4,73.47-72.87S370.76,385,308.87,281.39Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-meeko-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-2",
    d: "M163,468c30.74-14,125-50.28,125.77-140.21S-.37,300.25-.37,300.25s-35.14,293.4,64.12,367.19c0,0,.84-1,2.26-2.82l33,239.63s60.89,32.78,62.33,20.92c9.82-81.37,54.42-149.79,14.73-180-26-19.78-102.76-54.77-86.76-114.83,4.31-16.18,22-56.49,10.42-80.57C76.93,502.29,132.27,482.09,163,468Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-7",
    d: "M196.64,385.56s56.35.94,80.9-40.42c7.44-12.52,27.22-26.89,32.86-45.2C310.4,299.94,202.64,331.42,196.64,385.56Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-3",
    d: "M139,390.28s17,10.63,33.44,8.79C195,396.56,211,376.64,211,376.64s39.61-1.44,52.54-32.31a21.14,21.14,0,0,1,10.76-11.12c9.6-4.36,25.05-12.31,32.89-21.42L291.52,180.13l-151-27.23S52.63,164,53.87,247,72.74,384.24,139,390.28Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-1",
    d: "M128.22,101.84s47.94-6.43,90.4,5.75,90.84-60.21,107.54-73.78c8.56-7,15.3-10.81,19.83-12.9a5.37,5.37,0,0,1,7.61,4.39c.83,9.42.76,28.11-7.86,52.83-12.68,36.33-25.12,91.83-34.89,107.3s20.79,23.59,11.54,80.69-37.16,78.4-60.78,50.4c-23.25-27.55-44.56-48-44.24-58.92s-2.36-62.83-17-71.79-26.86,35.12-35.14,46.5S147,257.07,145.82,264.74s-62.35,13-66.43,60.8,36.77,40.85,36.77,40.85,9.81,17.16,22.47,24.93c0,0-70.59-12.13-103.79-53.4-16.27-20.23-21.84-36.31-23.57-49-6.3-46.1,5.74-92.29,12.29-111,0,0-31.62-145,.6-173.63S94.46,101,128.22,101.84Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-11",
    d: "M175.89,339.14l.61,11.31a.94.94,0,0,0,1.83.25l3.79-11.17Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-12",
    d: "M150.53,307.53s-2.68-40.3,2.18-63.63,15.68-74.54,40.43-69.79,28.59,46.45,28.59,46.45L208.23,314Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-13",
    d: "M150.53,307.53s-2.68-40.3,2.18-63.63,15-25,15-25-16.47,70.58,36.77,92Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-14",
    d: "M184.38,335.83s3.27,3.71,4.62-.17,2.14-9.51,13.3-14c0,0-9.12-4.76-11.65.39S184.38,335.83,184.38,335.83Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-14",
    d: "M151.62,311.85s1.14,5.45,11.68,11.09c4.51,2.4,5.68,7.09,7.4,10.81,1.8,3.88,4.16,6.76,9,7.65C189.05,343.14,169.22,305.09,151.62,311.85Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-15",
    d: "M152.1,303.46a6.46,6.46,0,0,0-.48,8.39,16.38,16.38,0,0,0,11.3,6.41c10.6,1.35,7.89,12.18,7.89,15.12s4,7.39,8.85,8c5.09.67,9.61-3.77,10.19-8.62s0-8,6-9,11.49-3.88,12.35-9.77c.72-4.93-10.16-10.69-20.35-7.79a16.19,16.19,0,0,1-12.1-1.16C168.91,301.36,158.14,297.29,152.1,303.46Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-7",
    d: "M262.94,119.89s34.3,26.07,41.91,61.71c0,0,11.65-33.73,14.57-45.34,9.95-39.68,27.57-66.37,26.23-96.47a2,2,0,0,0-2.92-1.74C335.13,41.74,318.91,52.57,262.94,119.89Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-7",
    d: "M100.93,105.6s-58.42,26.92-63.07,37.06c0,0-30-117.3-1.8-120.44C47.47,21,49.05,40.94,100.93,105.6Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-3",
    d: "M116.16,366.39s7.78,3.3,22.67,2.48,63.3,3.89,63.3,3.89,6,1.82,8.88,3.88c1.55,1.12-13.55,18.27-35.26,22.39C157.48,402.49,134.1,396.49,116.16,366.39Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-6",
    d: "M157.86,115.48a29.73,29.73,0,0,0-18.68-6s19.69,20.86,19.92,37.74-19.39,67.13-4.39,66.66c8.53-.27,22.61-23.88,38.28-31.83,11.89-6,27.12,3.84,27.52.1.94-8.68,3.15-29.45,1.88-37.27-3.09-19,3.38-32.2,3.38-32.2-21.75-.77-24.34,53.36-24.34,53.36l-3,12.36L184,177.24S173.55,127.35,157.86,115.48Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-6",
    d: "M174.12,148.59s3.28-42.3,11.27-43,16.52,39.85,16.52,39.85v32.25l-14.68,3.67Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-7",
    d: "M316,264.08s-6,38.41-33.76,36.75c-19.66-1.17-39.23-21.17-48.67-32.32.58-1.42,1.54-3.94,4.05-5,28-11.39,55.26-9.93,50.54-34-.6-3.06-2.54-5.11-3.9-6.85l1-.47c9.23-4.44,7.18-29.06-14.7-33.85s-30.78,14.36-34.88,13,10-50.18-13.33-69.58c-2.83-2.35,1.18,46-4.39,47s-7.71-59.18-16.51-64.58c-6.55-4-2.92,62-8.24,59.83-10-4.08-19.55-46-19.55-46s-9.51,6.43-2.06,53.22c1.33,8.32-8.3,22.9-13.75,26.12l0,0a2.25,2.25,0,0,1-3.37-2c.22-10.54,4.18-17.42,5.45-24.9,1.64-9.67,3.91-36.41-3.5-35.59s-19.5,41.32-19.5,41.32-12-25.64-23.63-25.64,8.73,9.28,9.75,26.73c0,0-20.64-21.29-41.95-13.71-8.63,3.07-23.17,15.05-11.85,20.51s28.09-.53,32.09,6.79c2.81,5.15,19.52,25.59,29.19,37.27l-46.7-33.23S66.11,206.64,69,218.7c0,0,2.38,20.77,26.12,29.25a148.89,148.89,0,0,1,24.5,11.81,3.15,3.15,0,0,1,.65,5c-11.21,11.12-29.69,24.37-53,22.5-39.33-3.14-43.16-22.84-43.16-22.84s-12.89,22.24,7.39,35.54c-6.54-3.45-15.77-8.54-20.36-12.07q.67,5.14,1.66,10.28C20.24,315.3,38.85,343.55,81.6,348c-2.06-5.66-3-13-2.21-22.46,3.62-42.36,51.33-49,64.22-57.58,5.12-3.41,8.15-6.65,12.58-11.33,4.72-5,9.66-5.07,13.28-12.3,7.69-15.38,15.37-59.27,28.84-57.56s4.44,42.83,16.8,72c10.07,23.75,28.09,56.59,50,67.24,7.51,3.65,15.47,4.69,23.72,1.85C327.12,314.6,316,264.08,316,264.08Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-6",
    d: "M63,204.36s-10.64-4.09-23.31,4.7C35,212.3,3.21,253.34,7.9,283.42s26.49,35,48,24.55c0,0,6-5.32-5.34-9.58s-32.95-6-26.47-34,15.14-34,21.68-33c9.43,1.55,7.23-2.87,5.15-7s-1.16-13.18,9.48-14.11S63,204.36,63,204.36Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-16",
    d: "M136.81,254.17c1.76-7.49-8-17.78-6.39-15.88l-46.7-33.23S66.11,206.64,69,218.7c0,0,2.38,20.77,26.12,29.25a148.89,148.89,0,0,1,24.5,11.81C121.39,260.8,135.05,261.65,136.81,254.17Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-7",
    d: "M311.08,243S298,266.25,282.59,275a1.37,1.37,0,0,0,.71,2.56c8.48-.33,23.6-2.9,31.61-16.16C321.84,250,311.08,243,311.08,243Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-6",
    d: "M321.56,272.28s2.26-33.68-13-43.14c-7.36-4.59-15.43-7.87-17.15-5.72-3,3.8,9,4,15.37,17.18,4.31,9,10.47,38.26,8.52,57.24C315.34,297.84,321,282.1,321.56,272.28Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-7",
    d: "M138.83,368.87c7.82-.32,27.55-1.39,37.53-12.44,0,0,13.89,13.64,25.77,16.33.6.14-9,1.31-17.76,6.23s-21.29.42-24.55-2.72c-2.35-2.27-15-5.07-21.08-6.49A.46.46,0,0,1,138.83,368.87Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-16",
    d: "M276,219.33c-2.27.19-38.46,27.93-45.46,36.27-3,3.58-5.48,15,2.84,13.36,2.67-.53,1.18-4.2,7.37-5.67,31.06-7.37,52.14-9.67,47.42-33.69C287.53,226.54,283.56,218.66,276,219.33Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-1",
    d: "M158.34,366.28a5.92,5.92,0,0,1,1.31.86c3.26,3.14,15.79,7.66,24.55,2.73a47.43,47.43,0,0,1,5.72-2.7,94.78,94.78,0,0,1-13.56-10.74C171.73,361.56,165,364.53,158.34,366.28Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 126.88,
    cy: 303.2,
    rx: 3.99,
    ry: 2.37,
    transform: "translate(-50.95 26.78) rotate(-10.05)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 97.23,
    cy: 333.83,
    rx: 3.99,
    ry: 2.37,
    transform: "translate(-56.75 22.08) rotate(-10.05)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 122.34,
    cy: 329.77,
    rx: 3.99,
    ry: 2.37,
    transform: "translate(-55.65 26.4) rotate(-10.05)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 139.22,
    cy: 301.08,
    rx: 2.23,
    ry: 1.98,
    transform: "translate(-50.39 28.9) rotate(-10.05)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 104.15,
    cy: 346.53,
    rx: 2.23,
    ry: 1.98,
    transform: "translate(-58.85 23.48) rotate(-10.05)"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 113.92,
    cy: 323.28,
    rx: 1.68,
    ry: 1.5,
    transform: "translate(-54.65 24.83) rotate(-10.05)"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 121.55,
    cy: 312.01,
    rx: 3.99,
    ry: 2.37,
    transform: "translate(-52.56 25.99) rotate(-10.05)"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 139.21,
    cy: 326.59,
    rx: 3.99,
    ry: 2.37,
    transform: "translate(-54.84 29.29) rotate(-10.05)"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 113.94,
    cy: 306.06,
    rx: 2.68,
    ry: 1.27,
    transform: "matrix(0.98, -0.17, 0.17, 0.98, -51.64, 24.57)"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 127.39,
    cy: 320.53,
    rx: 2.03,
    ry: 1.27,
    transform: "translate(-53.96 27.14) rotate(-10.05)"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 120.88,
    cy: 343.97,
    rx: 1.5,
    ry: 1.27,
    transform: "translate(-58.15 26.36) rotate(-10.05)"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 129.96,
    cy: 296.48,
    rx: 2.22,
    ry: 1.32,
    transform: "translate(-49.73 27.22) rotate(-10.05)"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 129.5,
    cy: 336.56,
    rx: 2.22,
    ry: 1.32,
    transform: "translate(-56.73 27.75) rotate(-10.05)"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 107.55,
    cy: 335.8,
    rx: 2.22,
    ry: 1.32,
    transform: "translate(-56.93 23.91) rotate(-10.05)"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 135.51,
    cy: 312.22,
    rx: 2.22,
    ry: 1.75,
    transform: "translate(-52.39 28.43) rotate(-10.05)"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 107.16,
    cy: 317.67,
    rx: 1.42,
    ry: 1.12,
    transform: "translate(-53.77 23.56) rotate(-10.05)"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 113.98,
    cy: 339.25,
    rx: 2.22,
    ry: 1.75,
    transform: "translate(-57.43 25.09) rotate(-10.05)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-13",
    d: "M126.3,303.56s-45-10.52-95.81-8.18a490.6,490.6,0,0,1,95.58,9.35Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-13",
    d: "M136.89,311.45S81.08,313.69,22.6,332.79A592.9,592.9,0,0,1,137,312.89Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-13",
    d: "M113.32,338S62.83,361.89,16.5,402.35A593.39,593.39,0,0,1,114,339.25Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-13",
    d: "M123.1,327.35S72.56,340,22.48,368.16a571.1,571.1,0,0,1,101-39.55Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-13",
    d: "M121.37,324.07S70.25,334.12,18.79,359.7a570.73,570.73,0,0,1,102.86-34.35Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-13",
    d: "M120.57,318.33s-46.13,7.38-92.8,29a495.78,495.78,0,0,1,93-27.85Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-13",
    d: "M103.75,339.4S67.25,351,34,376.1a326.8,326.8,0,0,1,70.24-35.61Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-13",
    d: "M108.38,348.53s-23.58,9.83-55.44,40.76c0,0,34.7-30.42,56.12-39.67Z"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 232.69,
    cy: 323.94,
    rx: 2.37,
    ry: 3.99,
    transform: "translate(-126.88 496.55) rotate(-79.95)"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 237.22,
    cy: 350.52,
    rx: 2.37,
    ry: 3.99,
    transform: "translate(-149.3 522.96) rotate(-79.95)"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 220.34,
    cy: 321.82,
    rx: 1.98,
    ry: 2.23,
    transform: "translate(-134.99 482.64) rotate(-79.95)"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 245.64,
    cy: 344.03,
    rx: 1.5,
    ry: 1.68,
    transform: "translate(-135.96 525.89) rotate(-79.95)"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 238.01,
    cy: 332.75,
    rx: 2.37,
    ry: 3.99,
    transform: "translate(-131.16 509.07) rotate(-79.95)"
  })), _ellipse23 || (_ellipse23 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 220.35,
    cy: 347.33,
    rx: 2.37,
    ry: 3.99,
    transform: "matrix(0.17, -0.98, 0.98, 0.17, -160.1, 503.71)"
  })), _ellipse24 || (_ellipse24 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 245.62,
    cy: 326.81,
    rx: 1.27,
    ry: 2.68,
    transform: "translate(-119.02 511.65) rotate(-79.95)"
  })), _ellipse25 || (_ellipse25 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 232.17,
    cy: 341.28,
    rx: 1.27,
    ry: 2.03,
    transform: "translate(-144.38 510.35) rotate(-79.95)"
  })), _ellipse26 || (_ellipse26 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 238.68,
    cy: 364.72,
    rx: 1.27,
    ry: 1.5,
    transform: "translate(-162.08 536.12) rotate(-79.95)"
  })), _ellipse27 || (_ellipse27 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 229.6,
    cy: 317.22,
    rx: 1.32,
    ry: 2.22,
    transform: "translate(-122.81 487.96) rotate(-79.95)"
  })), _ellipse28 || (_ellipse28 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 230.06,
    cy: 357.3,
    rx: 1.32,
    ry: 2.22,
    transform: "translate(-161.9 521.51) rotate(-79.95)"
  })), _ellipse29 || (_ellipse29 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 252.01,
    cy: 356.54,
    rx: 1.32,
    ry: 2.22,
    transform: "translate(-143.03 542.49) rotate(-79.95)"
  })), _ellipse30 || (_ellipse30 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 224.05,
    cy: 332.97,
    rx: 1.75,
    ry: 2.22,
    transform: "translate(-142.89 495.5) rotate(-79.95)"
  })), _ellipse31 || (_ellipse31 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 252.4,
    cy: 338.41,
    rx: 1.12,
    ry: 1.42,
    transform: "translate(-124.85 527.91) rotate(-79.95)"
  })), _ellipse32 || (_ellipse32 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-meeko-13",
    cx: 245.58,
    cy: 360,
    rx: 1.75,
    ry: 2.22,
    transform: "translate(-151.74 539.01) rotate(-79.95)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-13",
    d: "M230.36,324.89s46.12,2.65,94.21,19.27a490.65,490.65,0,0,0-94.32-18.08Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-13",
    d: "M216.93,329.79s55.71,4,113.55,25a593.16,593.16,0,0,0-113.71-23.57Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-13",
    d: "M227,349.33s49.68,25.52,94.7,67.46a592.57,592.57,0,0,0-95.41-66.2Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-13",
    d: "M230.2,346.13s50.11,14.25,99.26,44a571.5,571.5,0,0,0-99.65-42.78Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-13",
    d: "M232,342.91s50.77,11.68,101.38,38.9a570.68,570.68,0,0,0-101.71-37.64Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-13",
    d: "M233,337.19s45.87,8.86,91.82,32a496,496,0,0,0-92.09-30.83Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-meeko-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-6",
    d: "M10.77,236.84S30.83,195,39.46,187.92s3.87-10.38-4.75-2.64c-6.4,5.75-21.12,29.21-21.12,29.21S10.6,232.62,10.77,236.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-meeko-6",
    d: "M15.88,205.69s23.93-35.37,23.75-43.11-4.75-23.05-6.51-9a55.3,55.3,0,0,1-9.56,24.28L8.29,185.52Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "eyes"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-meeko-18 eyeball",
    cx: 109.65,
    cy: 222.84,
    r: 31.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-meeko-19 pupil",
    cx: 109.65,
    cy: 222.84,
    r: 20.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-meeko-18 eyeball",
    cx: 246.07,
    cy: 226.79,
    r: 31.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-meeko-19 pupil",
    cx: 246.07,
    cy: 226.79,
    r: 20.82
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeko);
export default __webpack_public_path__ + "static/media/Meeko.04b98d54902841cece8e02969a4ea97c.svg";
export { ForwardRef as ReactComponent };